export const manageSubscriptionUrl = 'https://www.logos.com/account/subscriptions';
export const mobileEdSubscriptionUrl = 'https://www.logos.com/product/56677/mobile-ed-subscription';
